import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6" }
const _hoisted_4 = { class: "card border-0 rounded-0 bg-white authentication-card" }
const _hoisted_5 = { class: "card-body letter-spacing" }
const _hoisted_6 = { class: "fw-bold mb-0" }
const _hoisted_7 = { class: "mb-0 fs-md-15 fs-lg-16 text-paragraph sub-text" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20" }
const _hoisted_9 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "text-center mt-15 mt-sm-20 mt-md-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-arrow-left" }, null, -1 /* HOISTED */)
const _hoisted_13 = { class: "row justify-content-center" }
const _hoisted_14 = { class: "col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6" }
const _hoisted_15 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('feature.auth.forgot_password')) + "?", 1 /* TEXT */),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('feature.auth.$forgot_password.message')), 1 /* TEXT */),
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  title: "Email",
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && !_ctx.usernameIsValid }]]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                  placeholder: _ctx.$t('form.email.placeholder'),
                  required: "",
                  pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+"
                }, null, 10 /* CLASS, PROPS */, _hoisted_10), [
                  [_vModelText, _ctx.username]
                ])
              ]),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn transition fw-medium fs-md-15 fs-lg-16 d-block w-100",
                    type: "submit",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setPristine && _ctx.setPristine(...args)))
                  }, _toDisplayString(_ctx.$t('cta.submit')), 1 /* TEXT */))
                : (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 1 })),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "link-btn text-decoration-none fw-medium fs-md-15 fs-lg-16 position-relative"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.back_to_login')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ])
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ])
  ]))
}